import { Directive, inject } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';

const DEFAULT_DIAMETER = 20;
const FAB_DIAMETER = 24;

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- sizes Material's own progressIndicator marker
  selector: 'mat-progress-spinner[progressIndicator], mat-spinner[progressIndicator]',
  providers: [
    {
      provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
      useFactory: () => ({
        ...inject(MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, { skipSelf: true }),
        diameter: inject(MatFabButton, { optional: true, skipSelf: true }) ? FAB_DIAMETER : DEFAULT_DIAMETER,
      }),
    },
  ],
})
export class GlxyButtonProgressSpinnerDirective {}
